import useWindowSize from "hooks/useWindowSize";
import { useState, useEffect, useContext } from "react";
import "./group-view.scss";
import GroupViewItem from "./GroupViewItem";
import sendRequest from "hooks/useAxios";
import { articleDataToQuery, productDataToQuery } from "utils/helperFunctions";
import { unixToPersianDate } from "utils/helperFunctions";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { translateToReactSelect } from "utils/helperFunctions";

export default function GroupViewContainer({ GroupViewData, page }) {
  const [title, setTitle] = useState({});
  const [display, setDisplay] = useState({});
  const [colorList, setColorList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [modalData, setModalData] = useState();
  const [items, setItems] = useState([]);
  const [firstIndex, setFirstIndex] = useState(-1);
  const auth = useContext(WithAuthentication);
  // const sliceArray = (array) => {
  //   return array.slice((currentPage - 1) * 12, (currentPage - 1) * 12 + 12);
  // };
  // const specificItems = sliceArray(product.item);

  const [sectionData, setSectionData] = useState({
    title: "",
    config: "",
    toggleDisplay: true,
  });
  const [updater, setUpdater] = useState(true);

  const [isLoader, setIsLoader] = useState(false);
  const { width, height } = useWindowSize();

  let screen = useWindowSize().width;
  const titleHandler = (names, value) => {
    setTitle((prev) => {
      return { ...prev, [names]: value };
    });
  };

  const displayHandler = (names, value) => {
    setDisplay((prev) => {
      return { ...prev, [names]: value };
    });
  };
  const isFilteredPage = true;

  useEffect(() => {
    // setIsLoader(true);
    const hi = async () => {
      if (isFilteredPage) {
        let { data: temp } = await sendRequest("Find_color", {});
        let tempColorList = temp.map((value) => {
          return { value: value.id, label: value.title, color: value.hex };
        });
        setColorList(tempColorList);

        let { data: temp1 } = await sendRequest("Find_hashtags", {});

        let tempTagList = temp1.map((value) => {
          return { value: value.id, label: value.txt };
        });
        setTagList(tempTagList);

        // setTagList(translateToReactSelect(tempTagList, false));

        // setTagList(tempTagList);

        let { data: temp2 } = await sendRequest("Find_brand", {});
        let tempBrandList = temp2.map((value) => {
          return { value: value.id, label: value.name };
        });
        setBrandList(tempBrandList);

        // let { data: temp3 } = await sendRequest("Find_boxs_configs", {
        //   conditions: `pagecode/=/${idConfig.pagecode}@@boxcode/=/${idConfig.boxcode}`,
        // });

        // setSectionData({
        //   title: temp3[0].title,
        //   config: temp3[0].custom_config,
        //   toggleDisplay: temp3[0].toggle_display == "1" ? true : false,
        // });

        // if (type == 1) {
        //   let queryObj = {
        //     ...articleDataToQuery(temp3[0].custom_config, true, {
        //       tagList: tempTagList,
        //     }),
        //   };
        //   setModalData({
        //     ...queryObj,
        //     toggleDisplay: temp3[0].toggle_display == "1" ? true : false,
        //   });

        //   setSectionData((prev) => {
        //     return { ...prev, title: queryObj.title };
        //   });

        //   sendRequest("postfilter", {
        //     hashtags: queryObj.tags.map((value) => value.value).toString(),
        //     date: queryObj.dateRange[0],
        //     toTime: queryObj.dateRange[1],
        //   }).then(({ data }) => {
        //     setItems(
        //       data.items.map((value) => {
        //         return {
        //           title: value.title,
        //           date: unixToPersianDate(value.mtm),
        //           image: value.url,
        //           mtm: value.mtm,
        //           id: value.id,
        //           description: value.description,
        //         };
        //       })
        //     );
        //     setIsLoader(false);
        //   });
        // }
        // else if (type == 0) {
        //   let queryObj = {
        //     ...productDataToQuery(temp3[0].custom_config, true, {
        //       brandList: tempBrandList,
        //       colorList: tempColorList,
        //       tagList: tempTagList,
        //     }),
        //   };

        //   setModalData({
        //     ...queryObj,
        //     toggleDisplay: temp3[0].toggle_display == "1" ? true : false,
        //   });

        //   setSectionData((prev) => {
        //     return { ...prev, title: queryObj.title };
        //   });

        //   sendRequest("productfilter", {
        //     hashtags: queryObj.tags.map((value) => value.value).toString(),
        //     brandId: queryObj.brands.toString(),
        //     fromRate: queryObj.rankRange[0],
        //     toRate: queryObj.rankRange[1],
        //     fromPrice: queryObj.priceRange[0],
        //     toPrice: queryObj.priceRange[1],
        //     discount: queryObj.sortTypes.discounted,
        //     ascendingPrice: queryObj.sortTypes.cheapest,
        //     descendingPrice: queryObj.sortTypes.mostExpensive,
        //     ascendingTime: queryObj.sortTypes.newest,
        //     inventoryCount: queryObj.sortTypes.inventory,
        //   }).then(({ data }) => {
        //     setIsLoader(false);

        //     setItems(
        //       data.items.map((value) => {
        //         return {
        //           name: value.title,
        //           image: value.url,
        //           id: value.id,
        //           dis: value.description,
        //           brand: value.brand.name,
        //           price: value.main_price,
        //           score_count: value.rating_count,
        //           score: value.avg_rating,
        //         };
        //       })
        //     );
        //   });
        // }
      }
      // else {
      //   setItems([...specificItems]);
      //   setIsLoader(false);
      // }
    };
    console.log("cccc", tagList);

    hi();
  }, [updater]);

  if (screen < 601) {
    return (
      <div className="group-view-mobile mt-4">
        <ul className="nav nav-tabs border-0" id="myTab" role="tablist">
          {GroupViewData.map((value, index) => {
            if (
              display[`index${index}`] == true ||
              auth.userInfo.userType == 0
            ) {
              (firstIndex == -1 || index < firstIndex) && setFirstIndex(index);
              return (
                <li className="nav-item tab-width" role="presentation">
                  <button
                    className={`nav-link border-0 ${
                      index == firstIndex && "active"
                    }`}
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target={`#tab-${index}`}
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    {title[`index${index}`]}
                  </button>
                </li>
              );
            }
          })}
        </ul>
        <div className="tab-content" id="myTabContent">
          {GroupViewData.map((value, index) => {
            // if (
            //   display[`index${index}`] == true ||
            //   auth.userInfo.userType == 0
            // ) {
            return (
              <div
                className={` tab-pane fade border-0 ${
                  index == firstIndex && " show active"
                }`}
                id={`tab-${index}`}
                role="tabpanel"
              >
                <div>
                  <GroupViewItem
                    idConfig={value.idConfig}
                    Component={value.Component}
                    numberOf={value.numberOf}
                    title={value.title}
                    type={value.type}
                    items={value.items}
                    id={value.id}
                    Color={value.Color}
                    moreText={value.moreText}
                    index={index}
                    titleHandler={titleHandler}
                    displayHandler={displayHandler}
                    tempTagList={tagList}
                    tempBrandList={brandList}
                    tempColorList={colorList}
                  />
                </div>
              </div>
            );
            // }
          })}
        </div>
      </div>
    );
  } else {
    return (
      <>
        {GroupViewData.map((value) => {
          return (
            <GroupViewItem
              idConfig={value.idConfig}
              Component={value.Component}
              numberOf={value.numberOf}
              title={value.title}
              type={value.type}
              id={value.id}
              Color={value.Color}
              moreText={value.moreText}
              tempTagList={tagList}
              tempBrandList={brandList}
              tempColorList={colorList}
            />
          );
        })}
      </>
    );
  }
}
